import React, { useState } from "react";
import styled from "styled-components";
import {
  generateVacanciesOnboardingReport,
  getReportData,
} from "../../services/reports_services";

const ReportDetailModal = ({ className, visible, setVisible }) => {
  const [reportData, setReportData] = useState(null);
  const [obs, setObs] = useState({});
  const sendReportAndDetails = () => {
    generateVacanciesOnboardingReport({
      report_data: reportData,
      observacoes: obs,
    });
  };
  const handleInputChange = (row, val) => {
    setObs((prevState) => ({ ...prevState, [row]: val }));
  };
  if (visible) {
    if (!reportData) {
      getReportData().then((res) => setReportData(res));
    }

    return (
      <div className={className} onClick={() => setVisible(false)}>
        <div className="modal-container" onClick={(e) => e.stopPropagation()}>
          {reportData &&
            Object.keys(reportData).map((row, index) => {
              if (row == "etapa") {
                return <></>;
              }
              return (
                <table className="table-style">
                  <thead>
                    <>
                      <tr key={index} style={{ width: "100%" }}>
                        <th colspan={4} style={{ textAlign: "center" }}>
                          {row}
                        </th>
                      </tr>
                      <tr>
                        <th>Forma Ingresso</th>
                        <th>N° Matriculados</th>
                        <th>Vagas Disponíveis</th>
                        <th>Excedentes</th>
                      </tr>
                    </>
                  </thead>
                  <tbody>
                    {Object.keys(reportData[row]).map((d, idx) => {
                      return (
                        <tr key={index}>
                          <td key={idx}>{d}</td>
                          <td key={idx}>{reportData[row][d][0]}</td>
                          <td key={idx}>{reportData[row][d][1]}</td>
                          <td key={idx}>{reportData[row][d][2]}</td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td colspan={4} style={{ borderBottom: "0px" }}>
                        <div
                          className="input-type-style"
                          style={{
                            width: "100%",
                            height: "100px",
                            display: "flex",
                          }}
                        >
                          <textarea
                            onChange={(e) =>
                              handleInputChange(row, e.target.value)
                            }
                            placeholder="Observações"
                            className={"input-style"}
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              );
            })}
          <div className="w-100 d-flex flex-row justify-content-center">
            <button className="button" onClick={() => sendReportAndDetails()}>
              Enviar
            </button>
          </div>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};

export default styled(ReportDetailModal)`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  .modal-container {
    position: relative;
    left: 20%;
    top: 20%;
    width: 60%;
    height: 60%;
    background-color: #fff;
    z-index: 11;
    padding: 24px;
    cursor: default;
    overflow-y: auto;
    .table-style {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 20px;
      th,
      td {
        padding: 8px;
        text-align: left;
        border-bottom: 1px solid #ddd;
      }
    }
    .button {
      border: none;
      width: 30%;
      height: 30px;
      cursor: pointer;
      color: #ffff;
      border-radius: 5px;
      background-color: #499d96;
      text-align: center;
      outline: none;
    }
  }
`;
